// extracted by mini-css-extract-plugin
var _1 = "SettingsSectionUpsell-module__animateUploadProgressBarWidth--JZz1X";
var _2 = "SettingsSectionUpsell-module__animatedBackground--FfFRZ";
var _3 = "SettingsSectionUpsell-module__cards--XY3uq";
var _4 = "SettingsSectionUpsell-module__cardsWrapper--qMMT9";
var _5 = "SettingsSectionUpsell-module__contentWrapper--v7NwO";
var _6 = "SettingsSectionUpsell-module__description--PJ3gC";
var _7 = "SettingsSectionUpsell-module__header--Yzmn4";
var _8 = "SettingsSectionUpsell-module__headerUpgradeButton--PJoKx";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "cards", _4 as "cardsWrapper", _5 as "contentWrapper", _6 as "description", _7 as "header", _8 as "headerUpgradeButton" }
